export default "__VITE_ASSET__BVu1is76__"